import axios from "axios";
const apiURL = process.env.REACT_APP_API_URL;

export const wishListProducts = async () => {
  const jwt = JSON.parse(localStorage.getItem("jwt"));
  const userId = jwt.user._id;

  let productArray = JSON.parse(localStorage.getItem(`wishList_${userId}`)) || [];

  try {
    let res = await axios.post(`${apiURL}/api/product/wish-product`, {
      productArray,
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};